import ModerationControls from "common/ModerationControls";
import bem from "easy-bem";
import CommentList from "features/comments/blocks/CommentList";
import type { Person } from "features/people/data/types";
import { useDataQuery } from "hooks/useData";
import { useUser } from "hooks/useUser";
import React from "react";

import "./ModeratedUserBox.css";

const cn = bem("moderated-user-box");

type OwnProps = {
  /** Person.id пользователя, чью панель модерации показать (только для модераторов). */
  personId?: number | null;
  /** Если true, принудительно включает режим модератора. */
  moderatorMode?: boolean;
};

const ModeratedUserBox: React.FC<OwnProps> = ({ personId, moderatorMode }) => {
  const { isModerator, personId: myPersonId } = useUser();

  const isModeratorView =
    !!moderatorMode && isModerator && !!personId && personId !== myPersonId;

  // Модератор просматривает профиль другого пользователя
  const person = useDataQuery<Person>(`people/${personId}/`, !isModeratorView);

  if (!isModeratorView) return null;

  return (
    <div className={cn()}>
      {person?.id ? (
        <ModerationControls
          personId={person.id}
          userId={person.userId}
          canManage
        />
      ) : null}

      <CommentList
        commentTargetType={"person"}
        commentTargetId={Number(person?.id) || 0}
        isModerated={true}
        defaultExpanded={!!person?.isModerated}
      />
    </div>
  );
};

export default ModeratedUserBox;
